module.exports = __webpack_public_path__ + "static/media/Eyes_red.7147f8ed.svg";